import { Component, OnInit } from '@angular/core'
import { CommonModule, NgClass, NgForOf, NgIf } from '@angular/common'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { NgbAccordionModule, NgbModal } from '@ng-bootstrap/ng-bootstrap'
import { ActivatedRoute } from '@angular/router'
import { Observable, Subject, takeUntil } from 'rxjs'
import { ParametreDto } from 'src/app/parametre/data-access/http/dto/parametre-dto'
import { ParametreService } from 'src/app/parametre/data-access/http/parametre.service'
import { ParametreSimpleModalComponent } from 'src/app/parametre/feature/modals/parametre-simple-modal/parametre-simple-modal.component'
import { ParametreSpecifiqueBddEnedisModalComponent } from 'src/app/parametre/feature/modals/parametre-specifique-bdd-enedis-modal/parametre-specifique-bdd-enedis-modal.component'
import { ParametreTableauModalComponent } from 'src/app/parametre/feature/modals/parametre-tableau-modal/parametre-tableau-modal.component'
import { TypeEnum } from 'src/app/parametre/models/type.enum'
import { ParametreTableauDto } from 'src/app/parametre/data-access/http/dto/parametre-tableau-dto'
import { SunleonService } from 'src/app/sunleon/data-access/http/sunleon.service'

@Component({
  selector: 'app-parametres-modulable',
  templateUrl: './parametres-modulable.component.html',
  styleUrls: ['./parametres-modulable.component.scss'],
  standalone: true,
  imports: [NgIf, FormsModule, NgForOf, ReactiveFormsModule, NgClass, NgbAccordionModule, CommonModule],
})
export class ParametresModulableComponent {
  iconClicked = false
  parametres$: Observable<ParametreDto[]>
  readonly modals: any = {
    [TypeEnum.SIMPLE]: ParametreSimpleModalComponent,
    [TypeEnum.TABLEAU]: ParametreTableauModalComponent,
    [TypeEnum.SPECIFIQUE]: ParametreSpecifiqueBddEnedisModalComponent,
  }

  selectedRowIndex: number | null = null

datas: Map<string, string[][]> = new Map<string, string[][]>();
  private destroy$ = new Subject<void>();

  constructor(
    public parametreService: ParametreService,
    private modalService: NgbModal,
    private sunleonService: SunleonService
  ) {
    this.parametres$ = this.parametreService.getOverloadableParametres(); 
  }

  ngOnInit(): void {
    this.sunleonService.overloadableParametresTableau$
      .pipe(takeUntil(this.destroy$))
      .subscribe(({ parametreDto, valeurs }) => {
        const tableauDatas = (valeurs as any).datas || [];
        this.datas.set(parametreDto.code, tableauDatas);
      });

    this.sunleonService.overloadableParametresSpécifique$
      .pipe(takeUntil(this.destroy$))
      .subscribe(({ parametreDto, valeurs }) => {
        const specifiqueDatas = valeurs.lignes || [];
        this.datas.set(parametreDto.code, specifiqueDatas);
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  openEditionModal(parametreDto: ParametreDto) {
    const modalRef = this.modalService.open(this.modals[parametreDto.type], { size: 'lg' })
    const modalComponent = modalRef.componentInstance
    modalComponent.parametre = { ...parametreDto }
    modalComponent.overloadable = true
    modalRef.dismissed.subscribe((data) => {
      if (data) {
        parametreDto.valeur = data.valeur
      }
    })
  }

  openTableauEditionModal(parametreDto: ParametreDto) {
    const modalRef = this.modalService.open(this.modals[parametreDto.type], {size:'xl'} )
    const modalComponent = modalRef.componentInstance
    modalComponent.parametre = {...parametreDto}
    modalComponent.datas = {...(this.datas?.get(parametreDto.code) ?? {})};
    modalComponent.overloadable = true
    modalRef.dismissed.subscribe(data => {
      if (data) {
        this.datas.set(parametreDto.code, data.valeur.datas)
        parametreDto.valeur = data.valeur.parametreDto.valeur
      }
    })
  }

  openBddEnedisEditionModal(parametreDto: ParametreDto) {
    const modalRef = this.modalService.open(this.modals[parametreDto.type], {size:'xl'} )
    const modalComponent = modalRef.componentInstance
    modalComponent.parametre = {...parametreDto}
    modalComponent.overloadable = true
    modalRef.dismissed.subscribe(data => {
      if (data) {
        const updatedValue = data.valeur?.parametreDto?.valeur ?? data.parametreDto?.valeur
        if (updatedValue != null) {
          parametreDto.valeur = updatedValue
        }
        parametreDto.utilisateur = data.utilisateur ?? data.parametreDto?.utilisateur ?? parametreDto.utilisateur
        parametreDto.dateModification = data.dateModification ?? data.parametreDto?.dateModification ?? parametreDto.dateModification
      }
    })
  }

  handleRowClick(index: number): void {
    // Change la couleur de la ligne ou effectuez d'autres actions
    this.selectedRowIndex = index
  }

  isM0IParameter(parametreDto: ParametreDto): boolean {
    return parametreDto.code === 'M0I'
  }

  getM0IRows(value: string | null | undefined): Array<{ annee: string; valeur: string }> {
    if (!value) {
      return []
    }

    return value
      .split(';')
      .map((item) => item.trim())
      .filter((item) => item.length > 0)
      .map((item) => {
        const match = item.match(/^\[(.+?)\]\s*=\s*(.+)$/)
        if (!match) {
          return null
        }
        return {
          annee: match[1].trim(),
          valeur: match[2].trim(),
        }
      })
      .filter((item): item is { annee: string; valeur: string } => item !== null)
  }
}
